import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { App } from '@capacitor/app';
import { isNativePlatform } from './platform';

export function useBackButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) {
      return;
    }

    const listener = App.addListener('backButton', () => {
      if (pathname === '/') {
        App.minimizeApp();
      } else {
        navigate(-1);
      }
    });

    return () => {
      listener.then((handle) => handle.remove());
    };
  }, [pathname, navigate]);
}
